import type { FaireProductEntity } from "../../entity_types/product";

export const p_7fwscp3cme: FaireProductEntity = {
  token: "p_7fwscp3cme",
  type: "product",
  name: "Embroidered San Francisco Golden Gate Twins Pouch",
  brandToken: "b_c5lwttyyt1",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/c434a3c22863fbc97a655eb8e98a38e50d25c30440fadea2814ba2fef37d4fca.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2cb67776f5fbc30175d9cbc8d478e09840072a0dcc569d15f460ec29c5f62403.jpeg",
    "https://cdn.faire.com/fastly/93cf9b9bde4d5c170bd002da6874a5473b00309ee52f47efd5b6eade829ce7c5.jpeg",
    "https://cdn.faire.com/fastly/a7780d3845345fc85540d2c98b363c3a76b95bf68da32c202d44c2df48d78ac5.jpeg",
    "https://cdn.faire.com/fastly/baa001d91b37ef9f11bea5d45478a678edf0bb35e0082bd4d6f7c87cce07ad4a.jpeg",
    "https://cdn.faire.com/fastly/cf50c9986cfc3c0f5851868783686e2c75e2d0b0f376285f2759be8060a6cc68.jpeg",
  ],
  priceDollars: 15.25,
  description:
    "You can touch and feel the texture of the beautiful threads. Each thread color was carefully selected by the artist to capture the San Francisco spirit.\n\n• 9”x6”\n• 100% Cotton Canvas\n• 12oz thick very durable fabric\n• Protective inner fabric\n• Gold color zipper",
  tags: [],
  msrpDollars: 30.49,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:49.107Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
